import React from "react"
import clsx from "clsx"
import { useLocation } from "react-router-dom"

import { onlyPositiveNumber } from "utils"
import classes from "./CheckoutCashTypesCard.module.scss"

const CheckoutCashTypesCard = props => {
  const {
    active,
    total,
    cashType,
    setIsLinkPay,
    paymentScrollRef,
    multiplePayment,
    setMultiplePayment,
    setCashTypes
  } = props

  const location = useLocation()

  const scrollToBottom = () => {
    !!paymentScrollRef.current.scrollTo &&
      paymentScrollRef.current.scrollTo({
        left: 0,
        top: 100000,
        behaviour: "smooth"
      })
  }

  const handleAddPaymentType = () => {
    setIsLinkPay(false)

    setCashTypes(prev => {
      const exists =
        prev.some(c => c.value === cashType.value)

      if (multiplePayment) {
        if (exists) return prev.filter(c => c.value !== cashType.value)

        if (prev.length === 2) return prev

        const totalCashTypesAmount =
          prev.reduce((t, c) => t += Number(c.amount), 0)

        const residue =
          onlyPositiveNumber(
            total - totalCashTypesAmount
          )

        return [
          ...prev,
          {
            amount: residue === 0 ? 0 : Number(residue).toFixed(2),
            name: cashType.name,
            value: cashType.value,
            terminalName: cashType.terminalName,
            isTerminal: cashType.isTerminal
          }
        ]
      }

      if (exists) return prev

      return [{
        amount: total,
        name: cashType.name,
        value: cashType.value,
        terminalName: cashType.terminalName,
        isTerminal: cashType.isTerminal
      }]
    })

    scrollToBottom()
  }

  const handleChangeToLinkPay = () => {
    setIsLinkPay(true)

    setMultiplePayment(false)

    setCashTypes([
      {
        amount: total,
        name: cashType.name,
        value: cashType.value,
        terminalName: cashType.terminalName,
        isTerminal: cashType.isTerminal
      }
    ])
  }

  const handleChangeToPosPayment = () => {
    setIsLinkPay(false)

    setMultiplePayment(false)

    setCashTypes([
      {
        amount: total,
        name: cashType.name,
        value: cashType.value,
        terminalName: cashType.terminalName,
        isTerminal: cashType.isTerminal
      }
    ])
  }

  const handleClick = () => {
    const linkPayCashType =
      cashType.value === "SMS" ||
      cashType.value === "واتساپ"

    if (linkPayCashType) {
      return handleChangeToLinkPay()
    }

    if (cashType.isTerminal) {
      return handleChangeToPosPayment()
    }

    handleAddPaymentType()
  }

  const disabled =
    location.state?.mode === "placeOrder"

  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={clsx(
        classes["cashType"],
        active && classes["active"],
        disabled && classes["disabled"]
      )}
    >
      {cashType.name}
    </button>
  )
}

export default React.memo(CheckoutCashTypesCard)